import { inject } from '@angular/core';
import {
  CanActivateFn,
  GuardResult,
  MaybeAsync,
  Router,
} from '@angular/router';
import { TutorialService} from '@infra-adapters/services/tutorial.service';

export const TutorialGuard: CanActivateFn = (
  route, 
  state
): MaybeAsync<GuardResult> => {
  const tutorialService = inject(TutorialService);
  const router = inject(Router);
  if (!tutorialService.isTutorialCompleted()) {
    return true;
  } else {
      return router.createUrlTree(['/dashboard']);
  }
};
